import { render, staticRenderFns } from "./ComboDepartamente.vue?vue&type=template&id=f825b832&scoped=true&"
import script from "./ComboDepartamente.ts?vue&type=script&lang=ts&"
export * from "./ComboDepartamente.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f825b832",
  null
  
)

export default component.exports
import {QTable,QSpace,QInput,QIcon,QTr,QTd} from 'quasar'
component.options.components = Object.assign({QTable,QSpace,QInput,QIcon,QTr,QTd}, component.options.components || {})
